module.exports = "<textarea id=\"{{elementId}}\" #editor></textarea>\n<attachments [filesObj]=\"filesObj\" (attachmentsChanged)=\"emitNewAttachments($event)\"></attachments>\n"


//////////////////
// WEBPACK FOOTER
// ./mobile/src/components/shared/sn-tiny-editor/sn-tiny-editor.html
// module id = ./mobile/src/components/shared/sn-tiny-editor/sn-tiny-editor.html
// module chunks = 0